import { IPage } from '../../types/redux/page';

export const initialState: IPage = {
  deviceType: 'desktop' as 'desktop',
  pageType: 'EstateCalculator',
};

export function pageReducer(state: IPage = initialState): IPage {
  return state;
}
